<template>
  <nav class="reports-filter">
    <section class="reports-filter__section">
      <p class="reports-filter__subheading">
        {{ $t('common.reports.language') }}
      </p>
      <FormBaseCheckbox
        v-model="filters.shouldHaveEnglish"
        small
        label-i18-path="common.reports.english"
      />
      <FormBaseCheckbox
        v-model="filters.shouldHaveGerman"
        small
        label-i18-path="common.reports.german"
      />
    </section>
    <div class="reports-filter__divider" />
    <section class="reports-filter__section">
      <p class="reports-filter__subheading">
        {{ $t('common.reports.topics') }}
      </p>
      <FormBaseCheckbox
        v-for="tag in tagStories"
        :key="tag.name"
        v-model="checkedTags[tag.uuid]"
        small
        :label="tag.content.name"
      />
    </section>
  </nav>
</template>

<script lang="ts" setup>
const reportsStore = useReportsStore()

const { filters, tagStories, checkedTags } = storeToRefs(reportsStore)
</script>

<style lang="scss" scoped>
.reports-filter {
  position: sticky;
  top: 120px;

  &__subheading {
    @include heading-subheading;

    margin-bottom: 12px;
  }

  &__divider {
    width: 100%;
    height: 1px;
    margin: 16px 0;
    background-color: var(--paper-400);
  }
}
</style>
